import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* tslint:disable */

/* eslint-disable */

/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull aftersale-trakr-customer'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 17
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.amplitude.com/products-aftersale/Aftersale/events/main/latest)
 *
 * [Full Setup Instructions](https://data.amplitude.com/products-aftersale/Aftersale/implementation/aftersale-trakr-customer)
 */
import * as amplitude from '@amplitude/analytics-browser';
export var ApiKey = {
  development: '777810285d38909159f2c6d5c3fe9d67',
  production: '68d1ed107101e55550094cb728d1031d'
};
/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */

export var DefaultConfiguration = _objectSpread({
  plan: {
    version: '17',
    branch: 'main',
    source: 'aftersale-trakr-customer',
    versionId: '247d0b50-e50c-4ae8-aa93-f7a3d4447884'
  }
}, {
  ingestionMetadata: {
    sourceName: 'browser-typescript-ampli',
    sourceVersion: '2.0.0'
  }
});
export var Identify = function Identify(event_properties) {
  _classCallCheck(this, Identify);

  this.event_properties = event_properties;

  _defineProperty(this, "event_type", 'Identify');

  this.event_properties = event_properties;
};
export var Group = function Group() {
  _classCallCheck(this, Group);

  _defineProperty(this, "event_type", 'Group');
};
export var AskEcommerceHelp = function AskEcommerceHelp(event_properties) {
  _classCallCheck(this, AskEcommerceHelp);

  this.event_properties = event_properties;

  _defineProperty(this, "event_type", 'AskEcommerceHelp');

  this.event_properties = event_properties;
};
export var ViewTrackingInterface = function ViewTrackingInterface(event_properties) {
  _classCallCheck(this, ViewTrackingInterface);

  this.event_properties = event_properties;

  _defineProperty(this, "event_type", 'ViewTrackingInterface');

  this.event_properties = event_properties;
};

var getVoidPromiseResult = function getVoidPromiseResult() {
  return {
    promise: Promise.resolve()
  };
}; // prettier-ignore


export var Ampli = /*#__PURE__*/function () {
  function Ampli() {
    _classCallCheck(this, Ampli);

    _defineProperty(this, "disabled", false);

    _defineProperty(this, "amplitude", void 0);
  }

  _createClass(Ampli, [{
    key: "isInitializedAndEnabled",
    value: function isInitializedAndEnabled() {
      if (!this.amplitude) {
        console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
        return false;
      }

      return !this.disabled;
    }
    /**
     * Initialize the Ampli SDK. Call once when your application starts.
     *
     * @param options Configuration options to initialize the Ampli SDK with.
     */

  }, {
    key: "load",
    value: function load(options) {
      var _options$disabled, _options$environment, _options$client$apiKe, _options$client, _options$client2;

      this.disabled = (_options$disabled = options === null || options === void 0 ? void 0 : options.disabled) !== null && _options$disabled !== void 0 ? _options$disabled : false;

      if (this.amplitude) {
        console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
        return getVoidPromiseResult();
      }

      var env = (_options$environment = options === null || options === void 0 ? void 0 : options.environment) !== null && _options$environment !== void 0 ? _options$environment : 'development';
      var apiKey = (_options$client$apiKe = options === null || options === void 0 ? void 0 : (_options$client = options.client) === null || _options$client === void 0 ? void 0 : _options$client.apiKey) !== null && _options$client$apiKe !== void 0 ? _options$client$apiKe : ApiKey[env];

      if (options !== null && options !== void 0 && (_options$client2 = options.client) !== null && _options$client2 !== void 0 && _options$client2.instance) {
        var _options$client3;

        this.amplitude = options === null || options === void 0 ? void 0 : (_options$client3 = options.client) === null || _options$client3 === void 0 ? void 0 : _options$client3.instance;
      } else if (apiKey) {
        var _options$client4;

        this.amplitude = amplitude.createInstance();
        return this.amplitude.init(apiKey, undefined, _objectSpread(_objectSpread({}, DefaultConfiguration), options === null || options === void 0 ? void 0 : (_options$client4 = options.client) === null || _options$client4 === void 0 ? void 0 : _options$client4.configuration));
      } else {
        console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
      }

      return getVoidPromiseResult();
    }
    /**
     * Identify a user and set user properties.
     *
     * @param userId The user's id.
     * @param properties The user properties.
     * @param options Optional event options.
     */

  }, {
    key: "identify",
    value: function identify(userId, properties, options) {
      if (!this.isInitializedAndEnabled()) {
        return getVoidPromiseResult();
      }

      if (userId) {
        options = _objectSpread(_objectSpread({}, options), {}, {
          user_id: userId
        });
      }

      var amplitudeIdentify = new amplitude.Identify();
      var eventProperties = properties;

      if (eventProperties != null) {
        for (var _i = 0, _Object$entries = Object.entries(eventProperties); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];

          amplitudeIdentify.set(key, value);
        }
      }

      return this.amplitude.identify(amplitudeIdentify, options);
    }
    /**
     * Set Group for the current user
     *
     * @param groupType The group type.
     * @param groupName The group name.
     * @param options Optional event options.
     */

  }, {
    key: "setGroup",
    value: function setGroup(groupType, groupName, options) {
      if (!this.isInitializedAndEnabled()) {
        return getVoidPromiseResult();
      }

      return this.amplitude.setGroup(groupType, groupName, options);
    }
    /**
     * Identify a group and set group properties.
     *
     * @param groupType The group type.
     * @param groupName The group name.
     * @param options Optional event options.
     */

  }, {
    key: "groupIdentify",
    value: function groupIdentify(groupType, groupName, options) {
      if (!this.isInitializedAndEnabled()) {
        return getVoidPromiseResult();
      }

      var amplitudeIdentify = new amplitude.Identify();
      return this.amplitude.groupIdentify(groupType, groupName, amplitudeIdentify, options);
    }
    /**
     * Track event
     *
     * @param event The event to track.
     * @param options Optional event options.
     */

  }, {
    key: "track",
    value: function track(event, options) {
      if (!this.isInitializedAndEnabled()) {
        return getVoidPromiseResult();
      }

      return this.amplitude.track(event, undefined, options);
    }
    /**
     * AskEcommerceHelp
     *
     * [View in Tracking Plan](https://data.amplitude.com/products-aftersale/Aftersale/events/main/latest/AskEcommerceHelp)
     *
     * **Evento que identifica quando um consumidor solicita ajuda ao e-commerce dado um problema na entrega.**
     *
     * Owner: TI Aftersale
     *
     * @param properties The event's properties (e.g. EcommerceName)
     * @param options Amplitude event options.
     */

  }, {
    key: "askEcommerceHelp",
    value: function askEcommerceHelp(properties, options) {
      return this.track(new AskEcommerceHelp(properties), options);
    }
    /**
     * ViewTrackingInterface
     *
     * [View in Tracking Plan](https://data.amplitude.com/products-aftersale/Aftersale/events/main/latest/ViewTrackingInterface)
     *
     * Ato de visualizar (ou entrar na pagina web) a interface de rastreio do JE pelo consumidor.
     *
     * Owner: TI Aftersale
     *
     * @param properties The event's properties (e.g. EcommerceName)
     * @param options Amplitude event options.
     */

  }, {
    key: "viewTrackingInterface",
    value: function viewTrackingInterface(properties, options) {
      return this.track(new ViewTrackingInterface(properties), options);
    }
  }, {
    key: "client",
    get: function get() {
      this.isInitializedAndEnabled();
      return this.amplitude;
    }
  }, {
    key: "isLoaded",
    get: function get() {
      return this.amplitude != null;
    }
  }]);

  return Ampli;
}();
export var ampli = new Ampli(); // BASE TYPES